import { combineReducers } from "redux";
import { navbarElementsForAdminsReducer } from "./navbarReducers";

const reducers = combineReducers({
    verticalNavbarElementsForAdmins: navbarElementsForAdminsReducer,
});

export default reducers;